
import React, { Component } from 'react';
import moment from 'moment';

import fox from '../assets/animal_10.png';
import wolf from '../assets/animal_20.png';
import cheetah from '../assets/animal_30.png';
import tiger from '../assets/animal_40.png';
import lion from '../assets/animal_50.png';
import grizzly from '../assets/animal_60.png';
import griffin from '../assets/animal_70.png';
import phoenix from '../assets/animal_80.png';
import dragon from '../assets/animal_90.png';

import pr from '../assets/pr.png';

const animals = {
  fox: fox,
  wolf: wolf,
  cheetah: cheetah,
  tiger: tiger,
  lion: lion,
  grizzly: grizzly,
  griffin: griffin,
  phoenix: phoenix,
  dragon: dragon
}

class ActivityRow extends Component {
  limitChars(string) {
    if(string.length > 68) {
      return string.slice(0, 68) + '...';
    }
    return string;
  }

  limitDesc(string) {
    if(string.length > 300) {
      return string.slice(0, 300) + '...';
    }
    return string;
  }

  render() {
    let ourDate = moment(this.props.activity.created_at);
    let workout_level = this.props.activity.workout_level ? this.props.activity.workout_level : 0;

    return (
      <div className="activity-row bottom-gray relative flex flex-wrap pa4">
        <div className="w-15">
          <div className="aspect-ratio aspect-ratio--1x1">
            <div 
              className="aspect-ratio--object cover br-100 z-1"
              style={{'backgroundImage': 'url(' + this.props.activity.member_image + ')'}}>
            </div>
          </div>
        </div>
        <div className="ml2 name-date tl w-85">
          <h2 className="name mt0 mb1 text-capitalize ttc">{this.props.activity.member_name}</h2>
          <p className="date mt1 mb0 light-text">{ourDate.format('YYYY-MM-DD')} / {ourDate.format('h:mm A')}</p>
          <p className="mt3 mb1 w-100 tl b">{this.limitChars(this.props.activity.workout_name)}</p>
          <p className="mt1 mb4 w-100 tl b t-blue">{this.props.activity.score}</p>
        </div>
        <br/>
        <p className="notes mt3 mb1 w-100 tl f3">{this.limitDesc(this.props.activity.notes)}</p>

        <div className="flex flex-wrap w-100">
          {this.props.activity.pr &&
            <div className="w-30 flex items-center justify-center mt3">
              <img className="icon-award" src={pr} /> Personal Record
            </div>
          }

          {(workout_level > 50 && this.props.activity.pr) &&
            <div className="connection w-05 flex items-center justify-center mt3">
              <div className="w-third tc">
                <div className="connection-dot center br-100">
                </div>
              </div>
              <div className="w-third tc">
                <div className="connection-dot center br-100">
                </div>
              </div>
              <div className="w-third tc">
                <div className="connection-dot center br-100">
                </div>
              </div>
            </div>
          }

          {workout_level > 50 &&
            <div className="w-30 flex items-center justify-center mt3">
              <img className="icon-award" src={animals[this.props.activity.workout_level_animal]} /> Level {this.props.activity.workout_level}
            </div>
          }

        </div>
      </div>
    )
  }
}

export default ActivityRow;


// WEBPACK FOOTER //
// ./src/components/ActivityRow.js